<div class="flex justify-center px-4">
  <div class="container mx-auto">
    <div class="flex flex-col lg:flex-row md:mt-32 mt-24 gap-8">
      <!-- Left: Filter Sidebar -->
      <app-filter
        *ngIf="showFilters"
        class="hidden md:block lg:w-1/4"
        [colors]="colors"
        [sizes]="sizes"
        [gender]="gender"
        [categories]="categories"
        [themes]="themes"
        [filters]="filters"
        (apply)="applyFilters()"
      ></app-filter>

      <!-- Right: Product Grid -->
      <main class="lg:w-3/4" [ngClass]="showFilters ? 'lg:w-3/4' : 'lg:w-full'">
        <h2 class="text-3xl font-extrabold mb-8 text-gray-900">All Products</h2>
        <div class="flex items-center gap-3 mb-6">
          <!-- Search Bar -->
          <div class="relative flex-1">
            <input
              type="text"
              placeholder="Search products..."
              name="search"
              [(ngModel)]="searchQuery"
              class="w-full px-4 py-3 pr-24 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)] focus:border-transparent transition"
            />
            <button
              (click)="onSearch()"
              class="absolute gap-1.5 bg-[var(--primary)] hover:bg-gray-900 py-2 px-4 rounded-lg flex items-center cursor-pointer right-2 top-1/2 -translate-y-1/2 text-white font-semibold text-sm transition"
            >
              <fa-icon [icon]="faSearch"></fa-icon>Search
            </button>
          </div>

          <!-- Filter Button -->
          <button
            class="flex cursor-pointer items-center justify-center w-12 h-12 bg-white border border-gray-300 rounded-xl text-gray-700 hover:bg-[var(--primary)] hover:text-white hover:border-[var(--primary)] transition"
            (click)="toggleFilters()"
          >
            <fa-icon [icon]="faFilter"></fa-icon>
          </button>
        </div>

        <app-filter
          [hidden]="!showFilters"
          class="md:hidden block mb-5"
          [colors]="colors"
          [sizes]="sizes"
          [gender]="gender"
          [categories]="categories"
          [themes]="themes"
          [filters]="filters"
          (apply)="applyFilters()"
        ></app-filter>

        <div
          class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6"
          [ngClass]="showFilters ? 'lg:grid-cols-4' : 'lg:grid-cols-5'"
        >
          @if (products$ | async; as products) {
            @if (products.length === 0) {
              <div class="col-span-full flex justify-center">
                <app-items-not-found
                  title="Product not found!"
                  description="We couldn’t find any products here."
                   [icon]="faBoxOpen"
                ></app-items-not-found>
              </div>
            }
            @for (product of products; track product.id) {
              <app-product
                [imageSrc]="product.images[0]"
                [title]="product.name"
                [price]="product.price"
                [oldPrice]="product.oldPrice"
                [id]="product.id"
                [product]="product"
              ></app-product>
            }
          } @else {
            <div class="col-span-full flex justify-center">
              <app-items-loading />
            </div>
          }
        </div>

        <div
          class="flex flex-col items-center mt-12 w-full"
          *ngIf="paginationInfo$ | async as pagination"
        >
          <div
            class="flex flex-col sm:flex-row sm:items-center w-full sm:w-auto px-3 py-3 rounded-lg gap-2 sm:gap-4"
          >
            <button
              class="px-3 sm:px-4 py-2 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              [disabled]="pagination.currentPage === 1"
              (click)="onPrevious($event)"
            >
              &laquo; <span class="sm:inline">Previous</span>
            </button>

            <div
              class="flex flex-wrap justify-center sm:justify-center flex-1 mx-0 sm:mx-2 space-x-1"
            >
              @for (
                page of getPageNumbers(
                  pagination.currentPage,
                  pagination.pageCount
                );
                track page
              ) {
                <button
                  class="w-8 h-8 text-xs font-medium rounded-lg transition-colors duration-150 border"
                  [class.text-white]="page === pagination.currentPage"
                  [class.bg-[#DC9D2A]]="page === pagination.currentPage"
                  [class.text-[#DC9D2A]]="page !== pagination.currentPage"
                  [class.bg-white]="page !== pagination.currentPage"
                  [class.border-gray-300]="page !== pagination.currentPage"
                  [class.hover\:bg-gray-100]="page !== pagination.currentPage"
                >
                  {{ page }}
                </button>
              }
            </div>

            <button
              class="px-3 sm:px-4 py-2 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              [disabled]="
                pagination.currentPage === pagination.pageCount ||
                pagination.pageCount == 0
              "
              (click)="onNext($event)"
            >
              <span class="sm:inline">Next</span> &raquo;
            </button>
          </div>

          <div class="mt-3 text-xs text-gray-600 text-center">
            Showing {{ pagination.from }} to {{ pagination.to }} of
            {{ pagination.totalCount }} items
          </div>
        </div>
      </main>
    </div>
  </div>
</div>
